import {
  ComponentCode,
  IsJoinLimit,
  JoinLimitType,
  MemberIdentityType,
  ResultComponentCode,
} from '@/config';
import { renderIntlLabel } from '@/utils';
import { parseFen2Currency } from '@/utils/number';

// 规则引擎显示
export const getFormatRulesTextFn = (...rest) => {
  const ruleItem = rest.shift();
  const memberLevelMap = rest.pop();
  const ruleFnMap = {
    /**
     * conditionRuleList
     */
    // 会员身份限制
    [ComponentCode.IdentityLimit]: (valueList) => {
      const item = valueList?.pop();
      const typeMap = {
        [MemberIdentityType.NoLimit]: () =>
          renderIntlLabel('guest_enum_MemberIdentityType_no_limit'),
        [MemberIdentityType.CommonMember]: () =>
          renderIntlLabel('guest_enum_MemberIdentityType_CommonMember'),
        [MemberIdentityType.NotCommonMember]: () =>
          renderIntlLabel('guest_enum_MemberIdentityType_NotCommonMember'),
        [MemberIdentityType.Level]: (value) => {
          return `${value?.map((val) => memberLevelMap[val]?.name)?.join(',')}`;
        },
      };
      if (typeof typeMap[item?.type] === 'function') {
        return typeMap[item?.type](item.value);
      }
      return '';
    },
    // 参与次数限制
    [ComponentCode.JoinLimit]: (valueList) => {
      const joinRuleItem = valueList?.pop();
      if (joinRuleItem.type === IsJoinLimit.limit) {
        const limitList = Array.isArray(joinRuleItem.value) ? [...joinRuleItem.value] : [];
        const limitItem = limitList?.pop();
        const list = Array.isArray(limitItem?.value) ? [...limitItem?.value] : [];
        const value = list?.pop();
        if (limitItem?.type === JoinLimitType.signalHotel) {
          return {
            label: renderIntlLabel('guest_coupon_label_join_counts_per_user_in_shop', { value }),
            value,
          };
        }
        if (limitItem?.type === JoinLimitType.allHotel) {
          return {
            label: renderIntlLabel('guest_coupon_label_join_counts_per_user_in_activity', {
              value,
            }),
            value,
          };
        }
        return { label: '', value: '' };
      }
      return { label: renderIntlLabel('guest_enum_MemberIdentityType_no_limit'), value: -1 };
    },
    // 充值门槛
    [ComponentCode.RechargeThreshold]: (valueList) => {
      const value = valueList?.pop();
      return { label: parseFen2Currency(value), value };
    },
    /**
     * resultRuleList
     */
    // 充送内容
    [ResultComponentCode.RechargeContent]: (valueList, item) => {
      return `${valueList?.[0] || ''}，${item?.ruleDesc || ''} x ${valueList?.[1] || ''}`;
    },
  };

  if (typeof ruleFnMap[ruleItem?.code] === 'function') {
    return ruleFnMap[ruleItem?.code](
      Array.isArray(ruleItem?.valueList) ? [...ruleItem?.valueList] : [],
      ruleItem,
    );
  }
  return '';
};

// 宾客核检 orderBy
export enum orderByKey {
  roomNoascend = 'roomNo,checkinTime', // 房号升序
  roomNodescend = 'roomNo desc,checkinTime', // 房号降序
  roomTypeNameascend = 'roomTypeId,checkinTime',
  roomTypeNamedescend = 'roomTypeId desc,checkinTime',
  checkInTimeascend = 'checkinTime', // 入住时间升序
  checkInTimedescend = 'checkinTime desc', // 入住时间降序
  checkOutTimeascend = 'checkoutTime',
  checkOutTimedescend = 'checkoutTime desc',
  memberTypeascend = 'memberType,checkinTime',
  memberTypedescend = 'memberType desc,checkinTime',
}

// 获取 orderBy
export const getOrderByKey = (obj: any) => {
  if (obj?.field && obj?.order) return orderByKey[`${obj.field}${obj.order}`];
  return orderByKey.roomNoascend;
};
